import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function CloudDowloadIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M5.6 11.056 8 13.5m0 0 2.4-2.444M8 13.5V8m4.8 2.898A3.38 3.38 0 0 0 14 8.306c0-1.857-1.477-3.362-3.3-3.362a.37.37 0 0 1-.32-.184C9.597 3.407 8.153 2.5 6.5 2.5 4.015 2.5 2 4.552 2 7.083a4.6 4.6 0 0 0 1.312 3.235" /></svg>
  );
}

export default CloudDowloadIcon;
